import React, { Component } from 'react';
// import AnimatedWrapper from '../AnimatedWrapper'
import { triggerIntroReveal } from '../App';

import Title from '../../components/navigation/Title'
import Hero from '../../components/hero/Hero.js'
import Shutter from '../../components/hero/transitions/Shutter'
import TimeLine from '../../components/timeline/TimeLine'
import Loading from '../../components/pageContent/Loading'
import { pushEvent } from '../../utils/analytics.js';

import { getUrl } from '../../utils/services.js'
import Footer from '../../components/footer/Footer.js';


class Page extends Component {

	constructor(props) {

		super(props)

		this.state = {
			isLoading: false,
			isLoaded: false,
			data: {}
		}

		this.getData = this.getData.bind(this)

	}

	getData() {

		this.setState({
			isLoading: true
		})

		getUrl('/api/timeline').then((data) => {			
			this.setState({
				// title: data.hero.fields.title,
				// subtitle: data.hero.fields.subtitle,
				// events: data.events,
				data,
				isLoading: false,
				isLoaded: true
			}, () => {
				if (this.props.onPageReady) {
					this.props.onPageReady();
				}
				triggerIntroReveal();
			})

		}).catch((err) => {
			console.log(err)
		})


	}

	componentDidMount() {
		pushEvent();
		this.getData()
	}


	render() {

		const { viewport, title } = this.props
		const { isLoading, isLoaded, data } = this.state

		const { hero, events } = data
		

		return (
			<div>

				<Title text={title} />

				{isLoading && <Loading />}

				{isLoaded && 

					<div>
						<Hero title={hero.fields.title} subtitle={hero.fields.subtitle} color="#eee" theme="light" viewport={viewport} isCentered={true}
							media={false}
							background={<Shutter height={100} />}
							showScroll={true}
						/>

						<TimeLine background="#eee" isLoading={isLoading} events={events} />

						<Footer viewport={viewport} />
					</div>

				}



			</div>
		);
	}
}

// const Wrapper = AnimatedWrapper(Page);
export default Page;